var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkediconwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 0C22.0406 0 22.7189 0.269354 23.219 0.748808C23.719 1.22826 24 1.87854 24 2.55659V20.4527C24 21.1308 23.719 21.7811 23.219 22.2605C22.7189 22.74 22.0406 23.0093 21.3333 23.0093H2.66667C1.95942 23.0093 1.28115 22.74 0.781048 22.2605C0.280951 21.7811 0 21.1308 0 20.4527V2.55659C0 1.87854 0.280951 1.22826 0.781048 0.748808C1.28115 0.269354 1.95942 0 2.66667 0H21.3333ZM20.6667 19.8136V13.0386C20.6667 11.9334 20.2087 10.8734 19.3936 10.0919C18.5784 9.31042 17.4728 8.87137 16.32 8.87137C15.1867 8.87137 13.8667 9.53609 13.2267 10.5332V9.11425H9.50667V19.8136H13.2267V13.5116C13.2267 12.5273 14.0533 11.722 15.08 11.722C15.5751 11.722 16.0499 11.9105 16.3999 12.2461C16.75 12.5818 16.9467 13.0369 16.9467 13.5116V19.8136H20.6667ZM5.17333 7.10732C5.76742 7.10732 6.33717 6.88107 6.75725 6.47833C7.17733 6.07558 7.41333 5.52935 7.41333 4.95979C7.41333 3.77097 6.41333 2.79947 5.17333 2.79947C4.57571 2.79947 4.00257 3.02707 3.57999 3.43221C3.1574 3.83735 2.92 4.38683 2.92 4.95979C2.92 6.1486 3.93333 7.10732 5.17333 7.10732ZM7.02667 19.8136V9.11425H3.33333V19.8136H7.02667Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkediconwhite);
export default __webpack_public_path__ + "static/media/linkediconwhite.68414b579af96dfebdbcb1b38fa90802.svg";
export { ForwardRef as ReactComponent };